import BaseService from "./BaseService";

export default class HistoricoEscolarService extends BaseService {

  constructor(self) {
    super(self);
  }

  ObterHistoricoEscolar(parameters) {
    return this.ExecutaFetch("/api/HistoricoEscolar/ObterHistoricoEscolar", "POST", parameters);
  }
}